/* reading-aids-follow-ups.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./reading-aids-follow-ups.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button, { IconButton } from '@atlaskit/button/new';
import { cx } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import RovoChatIcon from '@atlaskit/icon/core/rovo-chat';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { usePublish } from '@atlaskit/rovo-triggers';
import { FollowUpButton } from '@atlassian/conversation-assistant-ui-components';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { useAnalytics } from '../../common/controller/analytics';
import { useAIAnswerContext } from '../ai-answer-context';
import { onExpandButtonClicked, onFollowUpSuggestionClick } from '../analytics';
import { messages } from './messages';
var styles = {
  followUpWrapperStyles: "_19bv1ejb _u5f31ejb _n3tdu2gc",
  followUpWrapperUpdateStyles: "_19bvpxbi _u5f3pxbi",
  dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
export var ReadingAidsFollowUps = function ReadingAidsFollowUps() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    onClose = _useAIAnswerContext.onClose,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var query = commonAttributes.query,
    answerString = commonAttributes.answerString,
    followUps = commonAttributes.followUps;
  var publish = usePublish('ai-mate');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllFollowUps = _useState2[0],
    setShowAllFollowups = _useState2[1];
  var canExpand = followUps.length > 1;
  var visibleFollowUps = showAllFollowUps ? followUps : followUps.slice(0, 1);
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_definitions_ux_uplift_exp'
    }),
    serveDefinitionsUXExp = _getFrontendExperimen.serveExperiment;
  var serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
  var onFollowupsExpand = useCallback(function () {
    fireAnalyticsEvent(onExpandButtonClicked(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      expandButtonSource: 'follow-ups'
    })));
    setShowAllFollowups(!showAllFollowUps);
  }, [fireAnalyticsEvent, commonAttributes, showAllFollowUps]);
  var onFollowUpClick = useCallback(function (followUp) {
    if (readingAidsOptions !== null && readingAidsOptions !== void 0 && readingAidsOptions.onFollowUpCallback) {
      readingAidsOptions.onFollowUpCallback(followUp);
      return;
    }
    fireAnalyticsEvent(onFollowUpSuggestionClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      followUpString: followUp
    })));
    publish({
      type: 'chat-new',
      source: 'reading-aids',
      data: {
        name: followUp.substring(0, 30),
        dialogues: [{
          human_message: {
            content: formatMessage(messages.reading_aids_follow_ups_user_initial_query, {
              // query only contains the word that user asked
              // we want to add the word "define" before it so it makes sense
              // when this is moved to the chat
              term: query
            })
          },
          agent_message: {
            content: answerString
          }
        }],
        prompt: followUp
      }
    });
    onClose === null || onClose === void 0 || onClose();
  }, [query, answerString, publish, formatMessage, onClose, readingAidsOptions, commonAttributes, fireAnalyticsEvent]);
  if (!(followUps !== null && followUps !== void 0 && followUps.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.followUpWrapperStyles, serveDefinitionUXUpdates && styles.followUpWrapperUpdateStyles)
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, serveDefinitionUXUpdates && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.dividerStyles
  }), visibleFollowUps.map(function (followUp, index) {
    return /*#__PURE__*/React.createElement(Inline, {
      space: "space.050",
      alignBlock: "center",
      spread: serveDefinitionUXUpdates ? 'space-between' : undefined
    }, serveDefinitionUXUpdates ? /*#__PURE__*/React.createElement(Button, {
      key: followUp,
      iconBefore: RovoChatIcon,
      spacing: "compact",
      onClick: function onClick() {
        return onFollowUpClick(followUp);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      maxLines: 1,
      color: "color.text.subtle",
      weight: "medium"
    }, followUp)) : /*#__PURE__*/React.createElement(FollowUpButton, {
      key: followUp,
      followUpIndex: index,
      followUpText: followUp,
      followUpType: "UNAVAILABLE",
      experienceId: "reading-aids",
      onClick: function onClick() {
        return onFollowUpClick(followUp);
      }
    }), index === 0 && canExpand && /*#__PURE__*/React.createElement(IconButton, {
      onClick: onFollowupsExpand,
      icon: function icon(iconProps) {
        return showAllFollowUps ? /*#__PURE__*/React.createElement(ChevronDownIcon, _extends({}, iconProps, {
          color: "currentColor",
          testId: "collapse-follow-ups-icon",
          size: "small"
        })) : /*#__PURE__*/React.createElement(ChevronRightIcon, _extends({}, iconProps, {
          color: "currentColor",
          testId: "expand-follow-ups-icon",
          size: "small"
        }));
      },
      appearance: "subtle",
      label: showAllFollowUps ? 'Collapse follow ups button' : 'Expand follow ups button'
    }));
  })));
};